import { useEffect, useState } from 'react'
import { decodeHTML, handleContentError } from '../utils'

type GetModalDataProps = {
  callback: () => Promise<any>
  modalType: string
}

const useGetModalData = ({ callback, modalType }: GetModalDataProps) => {
  const [title, setTitle] = useState('')
  const [text, setText] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = async () => {
    setLoading(true)
    await callback()
      .then((resp) => {
        const content = resp?.collections?.[0]
        const contentText = content?.content?.[0]?.text ?? ''

        setTitle(decodeHTML(content?.title))
        setText(decodeHTML(contentText))
      })
      .catch(({ error, url }) => {
        setTitle(modalType)
        setText(
          `We weren't able to load the ${modalType} information at this time. You can access it on the web at https://www.pbs.org/cc-info/`
        )

        handleContentError(`${modalType}`, error, url)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  return {
    title,
    text,
    loading,
  }
}

export default useGetModalData
